import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import DataTable from '../datatable'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'

const columns = [
  {
    name: 'title',
    label: 'Otsikko',
    id: true,
    sortable: true,
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
]

export default function ContactRoot() {
  return <DataTable id="articles" entity="article" crud title="Artikkelit" columns={columns} />
}
